export default {"src":"/_next/static/image/public/images/ic_call.2e9bd6de647b1364f05dc7f10015724c.svg","height":34,"width":34};